import { Autocomplete, Box, Stack, TextField, Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import InputMask from "react-input-mask";
import marker from "../../../images/Markers.png";
import { ufList } from "../../../utils/ufList";
import api from "../../../services/api";
import { FieldAutocomplete } from "../../../components/Fields";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "24px",
  },
  boxRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: "24px",
  },
  typography: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontWeight: 600,
    color: "#063F5E",
  },
  stackText: { width: "100%" },
};

export default function EnderecoStep({ setDadosPaciente, dadosPaciente }) {
  const [disableLogradouro, setDisableLogradoura] = useState(false);
  const [disableBairro, setDisableBairro] = useState(false);
  const [disablebleMunicipio, setDisableMunicipio] = useState(false);
  const [disableEstado, setDisableEstado] = useState();
  const [municipioList, setMunicipioList] = useState([]);

  const inputRef = useRef(null);

  const handleUfChange = async (event, newValue) => {
    const uf_id = newValue.codigo_uf;
    setDadosPaciente((prevState) => ({
      ...prevState,
      enderecoCodigoUf: uf_id ?? "",
    }));

    handleMunicipioChange(uf_id);
  };

  useEffect(() => {}, []);

  const handleMunicipioChange = async (uf) => {
    try {
      const { data } = await api.post("/city", {
        state_id: parseInt(uf),
      });

      setMunicipioList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  };

  useEffect(() => {
    async function handleCep(auxCep) {
      try {
        const { data } = await axios.get(`
        https://viacep.com.br/ws/${auxCep}/json`);

        setDadosPaciente((prevState) => ({
          ...prevState,
          enderecoCep: auxCep,
          enderecoLogradouro: data.logradouro,
          enderecoBairro: data.bairro,
          enderecoCodigoUf: data.ibge.slice(0, 2),
          enderecoIBGE: parseInt(data.ibge),
        }));

        handleMunicipioChange(data.ibge.slice(0, 2));

        if (data.bairro) {
          setDisableBairro(true);
        } else {
          setDisableBairro(false);
        }
        if (data.logradouro) {
          setDisableLogradoura(true);
        } else {
          setDisableLogradoura(false);
        }

        if (data.localidade) {
          setDisableMunicipio(true);
        } else {
          setDisableMunicipio(false);
        }
        if (data.bairro) {
          setDisableEstado(true);
        } else {
        }
      } catch (error) {
        console.error();
      }
    }

    const auxCep = dadosPaciente.enderecoCep.replace(/\D/g, "");
    if (auxCep.length === 8) {
      handleCep(auxCep);
    } else {
      setDisableEstado(false);
      setDisableMunicipio(false);
      setDisableLogradoura(false);
      setDisableBairro(false);
    }
  }, [dadosPaciente.enderecoCep]);

  return (
    <Box sx={styles.container}>
      <Box
        sx={{
          ...styles.boxRow,
          flexDirection: { xs: "column", sm: "row" },
        }}
        id={"coluna1"}
      >
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>
            CEP <img src={marker} alt="maker" />
          </Typography>
          <InputMask
            mask="99999-999"
            definitions={{
              "#": /[1-9]/,
            }}
            value={dadosPaciente.enderecoCep}
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                enderecoCep: event.target.value,
              }));
            }}
          >
            {() => <TextField inputRef={inputRef} fullWidth />}
          </InputMask>
        </Stack>
        <Stack sx={styles.stackText}>
          <FieldAutocomplete
            label="Estado"
            disabled={disableEstado}
            getOptionLabel={(option) => option.unidade_federativa}
            options={ufList}
            value={
              ufList.find(
                (option) =>
                  option.codigo_uf ===
                  dadosPaciente.enderecoCodigoUf
              ) || null
            }
            setValue={(event, value) => handleUfChange(value)}
            required
          />
        </Stack>
      </Box>
      <Box
        sx={{
          ...styles.boxRow,
          flexDirection: { xs: "column", sm: "row" },
        }}
        id={"coluna2"}
      >
        <Stack sx={styles.stackText}>
        <FieldAutocomplete
          label="Município"
          disabled={disablebleMunicipio}
          getOptionLabel={(option) => option.no_descricao || ""}
          options={municipioList}
          value={
            municipioList
              ? municipioList.find(
                  (option) =>
                    option.co_ibge ===
                    dadosPaciente.enderecoIBGE
                )
              : null
          }
          setValue={(event, value) =>
            setDadosPaciente((prevState) => ({
              ...prevState,
              enderecoIBGE: value?.co_ibge,
            }))
          }
        />
        </Stack>
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>
            Bairro <img src={marker} alt="maker" />
          </Typography>
          <TextField
            disabled={disableBairro}
            value={dadosPaciente.enderecoBairro}
            fullWidth
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                enderecoBairro: event.target.value,
              }));
            }}
          />
        </Stack>
      </Box>
      <Box sx={styles.boxRow} id={"coluna3"}>
        <Stack direction={"column"} width={"100%"}>
          <Typography sx={styles.typography}>
            Logradouro <img src={marker} alt="maker" />
          </Typography>
          <TextField
            disabled={disableLogradouro}
            value={dadosPaciente.enderecoLogradouro}
            fullWidth
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                enderecoLogradouro: event.target.value,
              }));
            }}
          />
        </Stack>
      </Box>
      <Box
        sx={{
          ...styles.boxRow,
          flexDirection: { xs: "column", sm: "row" },
        }}
        id={"coluna4"}
      >
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>Número</Typography>

          <TextField
            value={dadosPaciente.enderecoNumero}
            fullWidth
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                enderecoNumero: event.target.value,
              }));
            }}
          />
        </Stack>
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>Complemento</Typography>
          <TextField
            value={dadosPaciente.enderecoComplemento}
            fullWidth
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                enderecoComplemento: event.target.value,
              }));
            }}
          />
        </Stack>
      </Box>
    </Box>
  );
}
